/* eslint-disable indent */
/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import * as Yup from 'yup';

const maxStringRequired = (maxChar = 255) =>
  Yup.string()
    .max(
      maxChar,
      i18n.t('MAX_LENGTH_KEY', {
        value: maxChar,
      })
    )
    .required(i18n.t('REQUIRED_FIELD_KEY'));

const maxStringNullable = (maxChar = 255) =>
  Yup.string()
    .max(
      maxChar,
      i18n.t('MAX_LENGTH_KEY', {
        value: maxChar,
      })
    )
    .nullable(true);

const ssoSchema = Yup.object().shape({
  allow_users_from_group: maxStringNullable(100),
  client_realm_id: maxStringRequired(30),
  federation_type: maxStringNullable(),
  restrict_access_by_groups: Yup.boolean().required(
    i18n.t('REQUIRED_FIELD_KEY')
  ),
  saml_idp_claim_email_address: maxStringRequired(),
  saml_idp_claim_given_name: maxStringRequired(),
  saml_idp_claim_groups: maxStringRequired(),
  saml_idp_claim_name_id: maxStringRequired(),
  saml_idp_claim_surname: maxStringRequired(),
  saml_idp_entity_id: maxStringRequired(),
  saml_idp_public_x509_cert: maxStringRequired(10000),
  saml_idp_single_logout_url: maxStringRequired(),
  saml_idp_single_sign_on_url: maxStringRequired(),
});

export default (
  limit?: number,
  virtualizer?: boolean,
  virtualizerType?: any,
  duo_enabled?: boolean,
  shouldValidateLicenseLimit?: boolean
) => {
  let licensesLimitSchema = Yup.number()
    .typeError(i18n.t('MUST_BE_A_NUMBER_KEY'))
    .min(
      0,
      i18n.t('MIN_VALUE_KEY', {
        value: 0,
      })
    );
  if (limit && shouldValidateLicenseLimit) {
    licensesLimitSchema = licensesLimitSchema.max(
      limit,
      i18n.t('LICENSE_LIMIT_MAX_KEY', {
        value: limit,
      })
    );
  }
  const portSchemaRules = Yup.number()
    .typeError(i18n.t('MUST_BE_A_NUMBER_KEY'))
    .min(
      0,
      i18n.t('MIN_VALUE_KEY', {
        value: 0,
      })
    )
    .max(
      2147483647,
      i18n.t('MAX_VALUE_KEY', {
        value: 2147483647,
      })
    );

  const portSchemaConnect =
    virtualizer === true ? Yup.number().nullable(true) : portSchemaRules;

  const portSchemaService =
    virtualizer === true || !['tsplus_all', 'tsplus'].includes(virtualizerType)
      ? Yup.number().nullable(true)
      : portSchemaRules;

  const portVirtualizerRules = Yup.string()
    .typeError(i18n.t('REQUIRED_FIELD_KEY'))
    .min(1, i18n.t('escolha uma opção por favor'));

  const portVirtualizer =
    virtualizer === true ? Yup.string().nullable(true) : portVirtualizerRules;

  const schemaShape: Record<string, any> = {
    name: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        70,
        i18n.t('MAX_LENGTH_KEY', {
          value: 70,
        })
      ),
    external_client_code: Yup.string()
      .max(
        20,
        i18n.t('MAX_LENGTH_KEY', {
          value: 20,
        })
      )
      .nullable(true),
    licenses: Yup.object().shape({
      license_limit: licensesLimitSchema,
    }),
    active_directory: Yup.object().shape({
      profile_path: Yup.string()
        .max(
          255,
          i18n.t('MAX_LENGTH_KEY', {
            value: 255,
          })
        )
        .nullable(),
    }),
    user_connection: Yup.object().shape({
      virtualizer: portVirtualizer,
      connect_port: portSchemaConnect,
      service_port: portSchemaService,
    }),
    environment_uuid: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    sso: Yup.object()
      .nullable(true)
      .when('sso_enabled', {
        is: true,
        then: () => ssoSchema,
        otherwise: schema => schema.nullable(true).notRequired(),
      }),

    duo: Yup.object()
      .shape({
        duo_client_id: duo_enabled
          ? Yup.string()
              .required(i18n.t('REQUIRED_FIELD_KEY'))
              .nullable(false)
          : Yup.string().nullable(),
        duo_client_secret: duo_enabled
          ? Yup.string()
              .required(i18n.t('REQUIRED_FIELD_KEY'))
              .nullable(false)
          : Yup.string().nullable(),
        host: duo_enabled
          ? Yup.string()
              .required(i18n.t('REQUIRED_FIELD_KEY'))
              .nullable(false)
          : Yup.string().nullable(),
      })
      .nullable(),
    observations: Yup.string().max(
      5000,
      i18n.t('MAX_LENGTH_KEY', {
        value: 5000,
      })
    ),
  };

  return Yup.object().shape(schemaShape);
};
